<script>
	import { Router, Route, Link } from "svelte-routing";
	import Home from "./Pages/Home.svelte";
	import TermsPage from "./Pages/TermsPage.svelte";
	import PrivacyPage from "./Pages/PrivacyPage.svelte";
	import NotFound from "./Pages/NotFound.svelte";
	import Profolio	from "./Pages/Profolio.svelte";
	import BrandDetail	from "./Pages/BrandDetail.svelte";

	export let url = "";

</script>

<Router url="{url}">
	<Route path="terms" component="{TermsPage}" /> 
	<Route path="privacy" component="{PrivacyPage}" /> 
	<Route path="/"><Home /></Route>
	<!-- <Route path="*" component="{NotFound}" />  -->
	<Route path="brand/:nickname/:brandId" let:params>
		<BrandDetail 
			nickname={params.nickname} 
			brandId={params.brandId} />
	</Route>
	<Route path="*wildcardName" let:params>
		{#if params.wildcardName[0] === "@"}
			<Profolio nickname={params.wildcardName.slice(1)} />
		{:else}
			<NotFound />
		{/if}
	</Route>
	<Route path="missing" component="{NotFound}" /> 
	<Route path="home"><Home /></Route>
</Router>